import { FunctionComponent, useMemo } from 'react';

import { CurrencyConnected, useGameStateSlice, useCoreSelector } from '@pp/core';

import { useMWStateSlice } from '../../store/slices/mwState/selectors';
import { useMWGameGridSlice } from '../../store/slices/mwGameGrid/selectors';
import { WinResult } from '../winResult';
import styles from './winResultLayer.module.css';

export const WinResultLayerConnected: FunctionComponent = () => {
  const gameResult = useMWStateSlice.getGameResult();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const winResult = useGameStateSlice.winResult();
  const winResultFormMW = useMWStateSlice.getWinningAmount();
  const hideWinMessage = useMWStateSlice.hideWinMessage();
  const gameStatus = useCoreSelector((state) => state.gameState.currentStatus);
  const streamViewableHeight = useMWGameGridSlice.getDimension('streamViewableHeight');

  const result = useMemo((): string | null => {
    return gameResult?.rc || null;
  }, [gameResult, isBetsOpenStatus]);

  const winAmountComponent = useMemo(() => {
    // This component is re-rendered on each stream transformation. To avoid child component re-render, passing memorized component to props
    const amount = winResultFormMW?.winingAmount ?? winResult?.amount;
    return amount ? <CurrencyConnected value={amount} /> : null;
  }, [winResult, winResultFormMW]);

  if (!streamViewableHeight) return null;

  return (
    <div className={styles.winResultLayer}>
      <div
        className={`${styles.winResultLayer__wrapper} ${
          ['YOU_WIN', 'MEGA_WIN'].includes(gameStatus) && styles.youWinResult_layer_wrapper
        }`}
      >
        <WinResult
          winAmount={winAmountComponent}
          result={result}
          winType={gameStatus}
          hideWinMessage={hideWinMessage}
        />
      </div>
    </div>
  );
};
